<script setup>
import wrapper from './sla.vue'
</script>
<template>
  <wrapper #="{ sla }" v-bind="$props">
    <div class="sla">
      <template v-if="!sla.started"> Не начато </template>
      <template v-else-if="sla.finished">
        <span class="text-primary"> {{ sla.slaLabelDone }} </span>
      </template>
      <template v-else-if="sla.progbarOn"><div class="hstack gap-2">
        <div class="label" :class="{ 'text-danger': sla.overdue }">
          {{ sla.slaLabelProgress }}
        </div>
        <div class="progress">
          <div
            :class="['progress-bar', `bg-${sla.color}`]"
            :style="{ width: sla.prog + '%' }"
          />
        </div>
      </div></template>
      <template v-else>Завершить до {{ sla.finDate }} </template>
    </div>
  </wrapper>
</template>
